import React, { useState } from 'react';
import { normalizeAnnouncementText } from '../services/announcementsService';

// line-clamp musi byt staticka trida, aby ji Tailwind nasel ve zdroji.
const CLAMP: Record<number, string> = {
  3: 'line-clamp-3',
  4: 'line-clamp-4',
  6: 'line-clamp-6',
  // Tailwind (CDN v3) ma v jadru jen line-clamp-1..6, vyssi hodnoty jen jako arbitrary.
  10: 'line-clamp-[10]',
};

/** Odhad, kdy uz text pretece – bez mereni DOM: pocet radku nebo delka. */
const jeDlouhy = (text: string, radku: number) =>
  text.split('\n').length > radku || text.length > radku * 90;

/**
 * Text novinky s ochranou zobrazení. Autor může vložit stovky odřádkování
 * nebo extrémně dlouhý text – bez ořezu by takový příspěvek rozbil celou
 * stránku. Text se proto srovná (normalizeAnnouncementText) a zkrátí na
 * daný počet řádků; zbytek se rozbalí na kliknutí.
 */
export const AnnouncementText: React.FC<{ text: string; radku?: number }> = ({ text, radku = 6 }) => {
  const [rozbaleno, setRozbaleno] = useState(false);
  const obsah = normalizeAnnouncementText(text);
  const dlouhy = jeDlouhy(obsah, radku);

  return (
    <div>
      <p
        className={`text-sm whitespace-pre-line break-words ${
          !rozbaleno && dlouhy ? CLAMP[radku] ?? 'line-clamp-6' : ''
        }`}
      >
        {obsah}
      </p>
      {dlouhy && (
        <button
          type="button"
          onClick={() => setRozbaleno((r) => !r)}
          className="mt-1 text-xs font-medium underline underline-offset-2 opacity-80 hover:opacity-100"
        >
          {rozbaleno ? 'Skrýt' : 'Zobrazit celé'}
        </button>
      )}
    </div>
  );
};
